import { memo, useState } from 'react';
import { TemplatesPopupTabs, TEMPLATES_REVAMP_TABS, PRESET_SECTIONS } from './constants';
import TemplatesList from '../../SideBar/Templates/TemplatesList';
import { ALL_TEMPLATES_LIMIT } from '../../constants';
import ClipCustomizerPanel from './ClipCustomizerPanel/ClipCustomizerPanel';
import ClipCustomizerTemplatesPresetSection from './ClipCustomizerTemplatesPresetSection';

function ClipCustomizerTemplatesPopupRevamp({
  isFullRecordingEdit = false,
  onClose
}: {
  isFullRecordingEdit?: boolean;
  onClose: () => void;
}) {
  const [activeTab, setActiveTab] = useState<TemplatesPopupTabs>(TemplatesPopupTabs.MyTemplates);

  return (
    <ClipCustomizerPanel
      heading="Templates"
      subHeading="Get started with one click"
      onClose={onClose}
      closeTrackingId="templates-popup-close"
      tabs={TEMPLATES_REVAMP_TABS}
      activeTab={activeTab}
      onTabChange={id => setActiveTab(id as TemplatesPopupTabs)}
    >
      {activeTab === TemplatesPopupTabs.MyTemplates && (
        <TemplatesList
          limit={ALL_TEMPLATES_LIMIT}
          queryParams={{ has_organization: false }}
          isInsidePopover
          isFullRecordingEdit={isFullRecordingEdit}
        />
      )}
      {activeTab === TemplatesPopupTabs.Preset && (
        <div>
          {PRESET_SECTIONS.map(section => (
            <ClipCustomizerTemplatesPresetSection key={section.size} {...section} />
          ))}
        </div>
      )}
    </ClipCustomizerPanel>
  );
}

export default memo(ClipCustomizerTemplatesPopupRevamp);
